import * as React from 'react';
import { ConfirmationOptions } from './interface';
import ConfirmationServiceContext from './confirmation-service-context';
import ConfirmationDialog from './confirmation-dialog';

const ConfirmationServiceProvider = ({ children }: any) => {
  const [confirmationState, setConfirmationState] = React.useState<ConfirmationOptions | null>(
    null,
  );

  const awaitingPromiseRef = React.useRef<{
    resolve:() => void;
    reject: () => void;
  }>();

  const openConfirmation = React.useCallback((options: ConfirmationOptions) => {
    setConfirmationState(options);
    return new Promise<void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  }, []);

  const handleClose = () => {
    if (confirmationState?.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    if (!confirmationState?.blockClosing) {
      setConfirmationState(null);
    }
  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setConfirmationState(null);
  };

  return (
    <>
      <ConfirmationServiceContext.Provider
        value={openConfirmation}
      >
        {children}
      </ConfirmationServiceContext.Provider>
      {confirmationState && (
        <ConfirmationDialog
          open={Boolean(confirmationState)}
          onSubmit={handleSubmit}
          onClose={handleClose}
          variant={confirmationState?.variant}
          icon={confirmationState?.icon}
          message={confirmationState?.message}
          cancelButtonTxt={confirmationState?.cancelButtonTxt}
          confirmButtonTxt={confirmationState?.confirmButtonTxt}
          containerRef={confirmationState?.containerRef}
          isHtmlMessage={confirmationState?.isHtmlMessage || false}
        />
      )}

    </>
  );
};

export default ConfirmationServiceProvider;
